import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./shifts.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getShiftsFlow(): SagaIterator {
  try {
    const response = yield call(api.getShifts)
    yield put(actions.getShiftsSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getShiftsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postShiftFlow(action: actions.PostShiftAction): SagaIterator {
  try {
    const response = yield call(api.postShift, action.payload)
    yield put(actions.postShiftSuccess(response && response.data))
  } catch (e) {
    yield put(actions.postShiftFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putShiftFlow(action: actions.PutShiftAction): SagaIterator {
  try {
    const { id, shift } = action.payload
    const response = yield call(api.putShift, id, shift)
    yield put(actions.putShiftSuccess(response && response.data))
  } catch (e) {
    yield put(actions.putShiftFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteShiftFlow(action: actions.DeleteShiftAction): SagaIterator {
  try {
    yield call(api.deleteShift, action.payload)
    yield put(actions.deleteShiftSuccess(action.payload))
  } catch (e) {
    yield put(actions.deleteShiftFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* shiftsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getShiftsFlow)
  yield takeLatest(actions.Types.POST, postShiftFlow)
  yield takeLatest(actions.Types.PUT, putShiftFlow)
  yield takeLatest(actions.Types.DELETE, deleteShiftFlow)
}
